import { render, staticRenderFns } from "./ScreenDisplayUi-sub.vue?vue&type=template&id=6f136ffa&scoped=true&"
import script from "./ScreenDisplayUi-sub.vue?vue&type=script&lang=js&"
export * from "./ScreenDisplayUi-sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f136ffa",
  null
  
)

export default component.exports